import React, { useState } from 'react';
import { Form, FormGroup, Label, Input, Col, Button, Card, CardBody, CardHeader } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Swal from 'sweetalert2';
import { SelectNet } from "../BasicComponents/SelectNet";
import { SelectUnitproxyApply } from "../BasicComponents/SelectUnitproxyApply";
import SelectReport from "../BasicComponents/SelectReport";
import SelectUrlTKBG from "../BasicComponents/SelectUrlTKBG";
import { api_url } from "../globalFunction/global_string";
import { FaTrash } from 'react-icons/fa';
import withReactContent from 'sweetalert2-react-content';

const riskLevelMapping = {
    '重要': 5,
    '高': 4,
    '中': 3,
    '低': 2,
    '資訊': 1
};
function CreateTrackingList() {
    const [formValues, setFormValues] = useState({
        projectName: '',
        projectStartTime: '',
        projectEndTime: '',
        riskLevels: [5, 4, 3], // 預設選中"高"和"中"
        selectedDuration: '1',
        isSubmitted: false
    });

    const MySwal = withReactContent(Swal);

    const [selectnet, setSelectnet] = useState("");
    const [local_net_name, setLocal_net_name] = useState("");
    const [selectUnit, setSelectUnit] = useState("");
    const [local_unit_name, setLocal_unit_name] = useState("");
    const [selecturl, setSelectUrl] = useState("");
    const [local_Url_name, setLocal_Url_name] = useState("");
    const [selectreport, setSelectreport] = useState("");
    const [local_report_name, setLocal_report_name] = useState("");
    const [trackingReports, setTrackingReports] = useState([
        { selectNet: '', selectUnit: '', selectUrl: '', selectReport: '', local_net_name: '', local_unit_name: '', local_Url_name: '', local_report_name: '', selectedDuration: '1' }
    ]);
    const userType = localStorage.getItem('login_user_type');
    const net_name = localStorage.getItem('login_user_net_name');
    const unit_name = localStorage.getItem('login_local_unit_name');


    const handleInputChange = (event) => {
        const { name, value } = event.target;

        // 檢查結束時間是否小於開始時間
        if (name === 'projectEndTime' && new Date(value) < new Date(formValues.projectStartTime)) {
            Swal.fire({
                title: '錯誤!',
                text: '追蹤計畫結束時間不能小於開始時間',
                icon: 'error',
                confirmButtonText: '好的'
            });
            return;
        }

        setFormValues(prevValues => ({
            ...prevValues,
            [name]: value
        }));
    };

    const handleRiskLevelChange = (event) => {
        const { value } = event.target;
        const numValue = riskLevelMapping[value];
        setFormValues(prevValues => ({
            ...prevValues,
            riskLevels: prevValues.riskLevels.includes(numValue)
                ? prevValues.riskLevels.filter(level => level !== numValue)
                : [...prevValues.riskLevels, numValue].sort((a, b) => a - b)
        }));
    };

    // 處理網域選擇
    const handleNetSelectChange = (data, index) => {
        const newReports = [...trackingReports];
        newReports[index] = {
            ...newReports[index],
            selectNet: data.value,
            local_net_name: data.selectedName,
            selectUnit: '',
            local_unit_name: '',
            selectUrl: '',
            local_Url_name: '',
            selectReport: '',
            local_report_name: ''
        };
        setTrackingReports(newReports);
    };


    // 處理單位選擇
    const selectUnitproxyApply = (data, index) => {
        const newReports = [...trackingReports];
        console.log(data)
        console.log(index)
        newReports[index] = {
            ...newReports[index],
            selectUnit: data.value,
            local_unit_name: data.selectedName,
            selectUrl: '',
            local_Url_name: '',
            selectReport: '',
            local_report_name: ''
        };
        setTrackingReports(newReports);
    };


    // 處理報告選擇
    const handleUrlChange = (data, index) => {
        const newReports = [...trackingReports];
        newReports[index] = {
            ...newReports[index],
            selectUrl: data.value,
            local_Url_name: data.selectedName,
            selectReport: '',
            local_report_name: ''
        };
        setTrackingReports(newReports);
    };


    // 處理報告選擇
    const selectReport = (data, index) => {
        const newReports = [...trackingReports];
        newReports[index] = {
            ...newReports[index],
            selectReport: data.value,
            local_report_name: data.selectedName
        };
        setTrackingReports(newReports);
    };


    //報告時間
    const durationOptions = [
        { label: '1個月', value: '1' },
        { label: '3個月', value: '3' },
        { label: '6個月', value: '6' },
        { label: '一年', value: '12' },
        { label: '二年', value: '24' },
        { label: '三年', value: '36' },
    ];

    // 處理報告風險數
    const handleDurationChange = (event) => {
        setFormValues(prevValues => ({
            ...prevValues,
            selectedDuration: event.target.value
        }));
    };


    // 新增追蹤報告
    const addTrackingReport = () => {
        setTrackingReports([
            ...trackingReports,
            { selectNet: '', selectUnit: '', selectUrl: '', selectReport: '', local_net_name: '', local_unit_name: '', local_Url_name: '', local_report_name: '', selectedDuration: '1' }
        ]);
    };
    // 更新指定追蹤報告的資料
    const updateTrackingReport = (index, field, value) => {
        const updatedReports = trackingReports.map((report, i) => {
            if (i === index) {
                return { ...report, [field]: value };
            }
            return report;
        });
        setTrackingReports(updatedReports);
    };
    const removeTrackingReport = (index) => {
        setTrackingReports(prevReports => prevReports.filter((_, i) => i !== index));
    };

    const handleSave = async () => {
        // 驗證邏輯
        if (formValues.projectName.trim() === '') {
            Swal.fire('錯誤', '請填寫專案名稱', 'error');
            return;
        }

        if (formValues.projectStartTime === '' || formValues.projectEndTime === '') {
            Swal.fire('錯誤', '請填寫追蹤計畫開始時間和結束時間', 'error');
            return;
        }

        if (new Date(formValues.projectEndTime) < new Date(formValues.projectStartTime)) {
            Swal.fire('錯誤', '結束追蹤時間不能早於追蹤時間', 'error');
            return;
        }

        if (formValues.riskLevels.length === 0) {
            Swal.fire('錯誤', '請至少選擇一個風險等級', 'error');
            return;
        }
        console.log(trackingReports)
        if (trackingReports.length === 0 || trackingReports.some(report => report.selectReport.trim() === '')) {
            Swal.fire('錯誤', '請至少新增一個追蹤報告', 'error');
            return;
        }

        // 新增檢查 selectReport 是否重複的邏輯
        const selectReportSet = new Set();

        for (const report of trackingReports) {
            console.log(report.id)
            if (selectReportSet.has(report.selectReport)) {
                Swal.fire('錯誤', '追蹤報告中有重複的報告', 'error');
                return;
            }
            selectReportSet.add(report.selectReport);
        }

        let apiUrl = api_url + '/api/TrackBackground/PostTrackBackgroundlist';
        let currentDateTime = new Date().toISOString();
        let allReportsSubmittedSuccessfully = true;
        for (const report of trackingReports) {
            const formData = new FormData();
            formData.set('projectHeavyRisk', formValues.riskLevels.includes(5) ? 'true' : 'false');
            formData.set('projectHighRisk', formValues.riskLevels.includes(4) ? 'true' : 'false');
            formData.set('projectMediumRisk', formValues.riskLevels.includes(3) ? 'true' : 'false');
            formData.set('projectLowRisk', formValues.riskLevels.includes(2) ? 'true' : 'false');
            formData.set('projectInformationRisk', formValues.riskLevels.includes(1) ? 'true' : 'false');
            formData.set('projectName', formValues.projectName);
            formData.set('projectStartTime', formValues.projectStartTime);
            formData.set('projectEndTime', formValues.projectEndTime);
            formData.set('selectedDuration', formValues.selectedDuration);
            formData.set('user_type', localStorage.getItem('login_user_type'));
            formData.set('local_net_id', localStorage.getItem('login_user_net_id'));
            formData.set('local_unit_id', localStorage.getItem('login_user_unit_id'));
            if (userType === 'S') {
                formData.set('projectnet', report.selectNet);
                formData.set('projectunit', report.selectUnit);
            } else if (userType === 'M') {
                formData.set('projectnet', localStorage.getItem('login_user_net_id'));
                formData.set('projectunit', report.selectUnit);
            } else if (userType === 'N') {
                formData.set('projectnet', localStorage.getItem('login_user_net_id'));
                formData.set('projectunit', localStorage.getItem('login_user_unit_id'));
            }
            formData.set('projecturl', report.selectUrl);
            formData.set('projecturlname', report.local_Url_name);
            formData.set('projectllimit', report.selectedDuration);
            formData.set('projectreport', report.selectReport);
            formData.set('projectreportname', report.local_report_name);
            formData.set('projectTemporarilySave', 'true');
            formData.set('build_date', formatDateTime(currentDateTime));
            if (userType === 'S') {
                formData.set('IsadminbuildTrack', 'true');
            } else if (userType === 'M') {
                formData.set('IsNetbuildTrack', 'true');
            } else if (userType === 'N') {
                formData.set('IsUnitbuildTrack', 'true');
            }
            formData.set('IsadminTrack', 'false');
            formData.set('IsNetTrack', 'false');
            formData.set('IsUnitTrack', 'false');


            for (const key in report) {
                formData.append(key, report[key]);
            }
            MySwal.fire({
                title: '處理中...',
                text: '報告建置中',
                allowOutsideClick: false,
                showConfirmButton: false,
                onBeforeOpen: () => {
                    MySwal.showLoading();
                }
            });
            try {
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: { "Authorization": localStorage.getItem('accessToken') },
                    body: formData
                });
                const data = await response.json();
                console.log(data.result.statusCode)
            } catch (error) {
                allReportsSubmittedSuccessfully = false;
                console.error('提交錯誤:', error);
            }

        }

        MySwal.close();

        if (allReportsSubmittedSuccessfully) {
            Swal.fire({
                title: '成功!',
                text: '所有追蹤報告儲存成功，您可以去追蹤清單查看',
                icon: 'success',
                confirmButtonText: '好的'
            });

            setFormValues({
                projectName: '',
                projectStartTime: '',
                projectEndTime: '',
                riskLevels: [5, 4, 3],
                selectedDuration: '1',
                isSubmitted: false,
            });
            setTrackingReports([
                { selectNet: '', selectUnit: '', selectUrl: '', selectReport: '', local_net_name: '', local_unit_name: '', local_Url_name: '', local_report_name: '', selectedDuration: '1' }
            ]);
        }
    };


    const handleSubmit = async (event) => {
        event.preventDefault();
        // 驗證邏輯
        if (formValues.projectName.trim() === '') {
            Swal.fire('錯誤', '請填寫專案名稱', 'error');
            return;
        }

        if (formValues.projectStartTime === '' || formValues.projectEndTime === '') {
            Swal.fire('錯誤', '請填寫追蹤計畫開始時間和結束時間', 'error');
            return;
        }

        if (new Date(formValues.projectEndTime) < new Date(formValues.projectStartTime)) {
            Swal.fire('錯誤', '結束追蹤時間不能早於追蹤時間', 'error');
            return;
        }

        if (formValues.riskLevels.length === 0) {
            Swal.fire('錯誤', '請至少選擇一個風險等級', 'error');
            return;
        }

        if (trackingReports.length === 0 || trackingReports.some(report => report.selectReport.trim() === '')) {
            Swal.fire('錯誤', '請至少新增一個追蹤報告', 'error');
            return;
        }
        let confirmSubmit = false;
        const selectReportSet = new Set();

        for (const report of trackingReports) {
            console.log(report.id)
            if (selectReportSet.has(report.selectReport)) {
                Swal.fire('錯誤', '追蹤報告中有重複的報告', 'error');
                return;
            }
            selectReportSet.add(report.selectReport);
        }
        confirmSubmit = await Swal.fire({
            title: '確定提交報告?',
            text: '提交後內容將無法更改',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: '確定',
            cancelButtonText: '取消'
        }).then(result => {
            return result.isConfirmed
        });

        if (!confirmSubmit) {
            return;
        }
        let apiUrl = api_url + '/api/TrackBackground/PostTrackBackgroundlist';
        let currentDateTime = new Date().toISOString();
        let allReportsSubmittedSuccessfully = true;
        for (const report of trackingReports) {
            const formData = new FormData();
            formData.set('projectHeavyRisk', formValues.riskLevels.includes(5) ? 'true' : 'false');
            formData.set('projectHighRisk', formValues.riskLevels.includes(4) ? 'true' : 'false');
            formData.set('projectMediumRisk', formValues.riskLevels.includes(3) ? 'true' : 'false');
            formData.set('projectLowRisk', formValues.riskLevels.includes(2) ? 'true' : 'false');
            formData.set('projectInformationRisk', formValues.riskLevels.includes(1) ? 'true' : 'false');
            formData.set('projectName', formValues.projectName);
            formData.set('projectStartTime', formValues.projectStartTime);
            formData.set('projectEndTime', formValues.projectEndTime);
            formData.set('selectedDuration', formValues.selectedDuration);
            formData.set('user_type', localStorage.getItem('login_user_type'));
            formData.set('local_net_id', localStorage.getItem('login_user_net_id'));
            formData.set('local_unit_id', localStorage.getItem('login_user_unit_id'));
            if (userType === 'S') {
                formData.set('projectnet', report.selectNet);
                formData.set('projectunit', report.selectUnit);
            } else if (userType === 'M') {
                formData.set('projectnet', localStorage.getItem('login_user_net_id'));
                formData.set('projectunit', report.selectUnit);
            } else if (userType === 'N') {
                formData.set('projectnet', localStorage.getItem('login_user_net_id'));
                formData.set('projectunit', localStorage.getItem('login_user_unit_id'));
            }
            formData.set('projecturl', report.selectUrl);
            formData.set('projecturlname', report.local_Url_name);
            formData.set('projectllimit', report.selectedDuration);
            formData.set('projectreport', report.selectReport);
            formData.set('projectreportname', report.local_report_name);
            formData.set('projectStore', 'true');
            formData.set('build_date', formatDateTime(currentDateTime));
            if (userType === 'S') {
                formData.set('IsadminbuildTrack', 'true');
            } else if (userType === 'M') {
                formData.set('IsNetbuildTrack', 'true');
            } else if (userType === 'N') {
                formData.set('IsUnitbuildTrack', 'true');
            }
            if (userType === 'S') {
                formData.set('IsadminTrack', 'true');
                formData.set('IsNetTrack', 'false');
                formData.set('IsUnitTrack', 'false');
            } else if (userType === 'M') {
                formData.set('IsNetTrack', 'true');
                formData.set('IsadminTrack', 'false');
                formData.set('IsUnitTrack', 'false');
            } else if (userType === 'N') {
                formData.set('IsUnitTrack', 'true');
                formData.set('IsNetTrack', 'false');
                formData.set('IsadminTrack', 'false');
            } else {
                formData.set('IsadminTrack', 'false');
                formData.set('IsNetTrack', 'false');
                formData.set('IsUnitTrack', 'false');
            }
            MySwal.fire({
                title: '處理中...',
                text: '報告建置中',
                allowOutsideClick: false,
                showConfirmButton: false,
                onBeforeOpen: () => {
                    MySwal.showLoading();
                }
            });
            for (const key in report) {
                formData.append(key, report[key]);
            }

            try {
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: { "Authorization": localStorage.getItem('accessToken') },
                    body: formData
                });
                const data = await response.json();
                console.log(data.result.statusCode)
            } catch (error) {
                allReportsSubmittedSuccessfully = false;
                console.error('提交錯誤:', error);
            }

        }
        MySwal.close();


        if (allReportsSubmittedSuccessfully) {
            Swal.fire({
                title: '成功!',
                text: '所有追蹤報告儲存成功，您可以去追蹤清單查看',
                icon: 'success',
                confirmButtonText: '好的'
            });

            setFormValues({
                projectName: '',
                projectStartTime: '',
                projectEndTime: '',
                riskLevels: [5, 4, 3],
                selectedDuration: '1',
                isSubmitted: false,
            });
            setTrackingReports([
                { selectNet: '', selectUnit: '', selectUrl: '', selectReport: '', local_net_name: '', local_unit_name: '', local_Url_name: '', local_report_name: '', selectedDuration: '1' }
            ]);
        }
    };

    function formatDateTime(isoString) {
        const date = new Date(isoString);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');

        return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
    }

    const renderTrackingReportForms = () => {
        return trackingReports.map((report, index) => (
            <Card key={index}>
                <CardHeader className="d-flex justify-content-between align-items-center">
                    追蹤報告 #{index + 1}
                    {index > 0 && (
                        <Button color="danger" onClick={() => removeTrackingReport(index)}>
                            <FaTrash />
                        </Button>
                    )}
                </CardHeader>
                <CardBody>
                    {renderFormDataUsertype(report, index)}
                </CardBody>
            </Card>
        ));
    };

    const renderFormDataUsertype = (report, index) => {
        if (userType === 'S') {
            return (
                <>
                    <FormGroup row>
                        <Label for={`local_net_id_${index}`} sm={2}>區網名稱</Label>
                        <Col sm={10}>
                            <SelectNet
                                parentName={`superS`}
                                id={`excel_net_name_${index}`}
                                name={`excel_net_name_${index}`}
                                requiredAPI={'/api/JRCC/GetLocalNetId'}
                                handleNetSelectChange={(data) => handleNetSelectChange(data, index)}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for={`excel_unit_proxy_name_${index}`} sm={2}>單位名稱</Label>
                        <Col sm={10}>
                            <SelectUnitproxyApply
                                parentName={'superS'}
                                id={`excel_unit_proxy_name_${index}`}
                                name={`excel_unit_proxy_name_${index}`}
                                requiredAPI={'/api/Async/GetNetDownUnitlist'}
                                SelectUnitproxyApply={(data) => selectUnitproxyApply(data, index)}
                                selectnet={report.selectNet}
                                local_net_name={report.local_net_name}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row inline>
                        <Label for={`TKBG_url_${index}`} sm={2}>網站名稱</Label>
                        <Col sm={10}>
                            <SelectUrlTKBG
                                parentName={'superSTKGB'}
                                id={`TKBG_url_${index}`}
                                name={`TKBG_url_${index}`}
                                requiredAPI={'/api/TrackBackground/GetUrlNamelist'}
                                handleUrlChange={(data) => handleUrlChange(data, index)}
                                selectnet={report.selectNet}
                                local_net_name={report.local_net_name}
                                selectunit={report.selectUnit}
                                local_unit_name={report.local_unit_name}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={2}>選擇時間範圍:</Label>
                        <Col sm={10}>
                            <Input
                                type="select"
                                name={`selectedDuration_${index}`}
                                value={report.selectedDuration}
                                onChange={(e) => updateTrackingReport(index, 'selectedDuration', e.target.value)}
                            >
                                {durationOptions.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </Input>
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Label for={`excel_report_list_${index}`} sm={2}>報告名稱</Label>
                        <Col sm={10}>
                            <SelectReport
                                parentName={'superS'}
                                id={`excel_report_list_${index}`}
                                name={`excel_report_list_${index}`}
                                requiredAPI={'/api/TrackBackground/GetReportlist'}
                                selectReport={(data) => selectReport(data, index)}
                                selectnet={report.selectNet}
                                local_net_name={report.local_net_name}
                                selectunit={report.selectUnit}
                                local_unit_name={report.local_unit_name}
                                selectUrl={report.selectUrl}
                                local_Url_name={report.local_Url_name}
                                selectedDuration={report.selectedDuration}
                            />
                        </Col>
                    </FormGroup>
                </>
            );
        } else if (userType === 'M') {
            return (
                <>
                    <FormGroup row inline>
                        <Label sm={2}>區網名稱</Label>
                        <Col sm={10}>
                            <span className="form-control-plaintext">{net_name}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for={`excel_unit_proxy_name_${index}`} sm={2}>單位名稱</Label>
                        <Col sm={10}>
                            <SelectUnitproxyApply
                                parentName={'superM'}
                                id={`excel_unit_proxy_name_${index}`}
                                name={`excel_unit_proxy_name_${index}`}
                                requiredAPI={'/api/Async/GetNetDownUnitlist'}
                                SelectUnitproxyApply={(data) => selectUnitproxyApply(data, index)}
                                selectnet={localStorage.getItem('login_user_net_id')}
                                local_net_name={net_name}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row inline>
                        <Label for={`TKBG_url_${index}`} sm={2}>網站名稱</Label>
                        <Col sm={10}>
                            <SelectUrlTKBG
                                parentName={'superMTKGB'}
                                id={`TKBG_url_${index}`}
                                name={`TKBG_url_${index}`}
                                requiredAPI={'/api/TrackBackground/GetUrlNamelist'}
                                handleUrlChange={(data) => handleUrlChange(data, index)}
                                selectunit={report.selectUnit}
                                local_unit_name={report.local_unit_name}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={2}>選擇時間範圍:</Label>
                        <Col sm={10}>
                            <Input
                                type="select"
                                name={`selectedDuration_${index}`}
                                value={report.selectedDuration}
                                onChange={(e) => updateTrackingReport(index, 'selectedDuration', e.target.value)}
                            >
                                {durationOptions.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </Input>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for={`excel_report_list_${index}`} sm={2}>報告名稱</Label>
                        <Col sm={10}>
                            <SelectReport
                                parentName={'superM'}
                                id={`excel_report_list_${index}`}
                                name={`excel_report_list_${index}`}
                                requiredAPI={'/api/TrackBackground/GetReportlist'}
                                selectReport={(data) => selectReport(data, index)}
                                selectunit={report.selectUnit}
                                local_unit_name={report.local_unit_name}
                                selectUrl={report.selectUrl}
                                local_Url_name={report.local_Url_name}
                                selectedDuration={report.selectedDuration}
                            />
                        </Col>
                    </FormGroup>
                </>)
        } else {
            return (
                <>
                    <FormGroup row inline>
                        <Label sm={2}>區網名稱</Label>
                        <Col sm={10}>
                            <span className="form-control-plaintext">{net_name}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup row inline>
                        <Label sm={2}>單位名稱</Label>
                        <Col sm={10}>
                            <span className="form-control-plaintext">{unit_name}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup row inline>
                        <Label for={`TKBG_url_${index}`} sm={2}>網站名稱</Label>
                        <Col sm={10}>
                            <SelectUrlTKBG
                                parentName={'superNTKGB'}
                                id={`TKBG_url_${index}`}
                                name={`TKBG_url_${index}`}
                                requiredAPI={'/api/TrackBackground/GetUrlNamelist'}
                                handleUrlChange={(data) => handleUrlChange(data, index)}

                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label sm={2}>選擇時間範圍:</Label>
                        <Col sm={10}>
                            <Input
                                type="select"
                                name={`selectedDuration_${index}`}
                                value={report.selectedDuration}
                                onChange={(e) => updateTrackingReport(index, 'selectedDuration', e.target.value)}
                            >
                                {durationOptions.map((option) => (
                                    <option key={option.value} value={option.value}>
                                        {option.label}
                                    </option>
                                ))}
                            </Input>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for={`excel_report_list_${index}`} sm={2}>報告名稱</Label>
                        <Col sm={10}>
                            <SelectReport
                                parentName={'superN'}
                                id={`excel_report_list_${index}`}
                                name={`excel_report_list_${index}`}
                                requiredAPI={'/api/TrackBackground/GetReportlist'}
                                selectReport={(data) => selectReport(data, index)}
                                selectUrl={report.selectUrl}
                                local_Url_name={report.local_Url_name}
                                selectedDuration={report.selectedDuration}
                            />
                        </Col>
                    </FormGroup>
                </>
            )
        }
    }
    return (
        <div>
            <Form onSubmit={handleSubmit}>
                <FormGroup row>
                    <Label for="projectName" sm={2}>追蹤計畫名稱:</Label>
                    <Col sm={10}>
                        <Input
                            type="text"
                            name="projectName"
                            id="projectName"
                            value={formValues.projectName}
                            onChange={handleInputChange}
                        />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="projectStartTime" sm={2}>追蹤計畫開始時間:</Label>
                    <Col sm={10}>
                        <Input
                            type="date"
                            name="projectStartTime"
                            id="projectStartTime"
                            min={new Date().toISOString().split('T')[0]}
                            value={formValues.projectStartTime}
                            onChange={handleInputChange}
                        />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label for="projectEndTime" sm={2}>追蹤計畫結束時間:</Label>
                    <Col sm={10}>
                        <Input
                            type="date"
                            name="projectEndTime"
                            id="projectEndTime"
                            min={new Date().toISOString().split('T')[0]}
                            value={formValues.projectEndTime}
                            onChange={handleInputChange}
                        />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Label sm={2}>風險層級:</Label>
                    <Col sm={10}>
                        <div className="d-flex flex-row">
                            {Object.entries(riskLevelMapping).map(([key, numValue]) => (
                                <FormGroup check inline key={key}>
                                    <Label check>
                                        <Input
                                            type="checkbox"
                                            name="riskLevels"
                                            value={key}
                                            checked={formValues.riskLevels.includes(numValue)}
                                            onChange={handleRiskLevelChange}
                                        />
                                        {key}
                                    </Label>
                                </FormGroup>
                            ))}
                        </div>
                    </Col>
                </FormGroup>
                {renderTrackingReportForms()}
                <Button onClick={addTrackingReport} color="success">新增追蹤報告</Button>
                {' '}
                <Button onClick={handleSave} color="secondary" >
                    儲存
                </Button>
                {' '}
                {/* <Button type="submit" color="primary" >
                    提交
                </Button> */}
            </Form>
        </div>
    );
}

export default CreateTrackingList;
